/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-router-dom components
import { useLocation } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import PageLayout from "examples/LayoutContainers/PageLayout";

// Authentication pages components
import Footer from "layouts/authentication/components/Footer";
import {useTranslation} from "react-i18next";

function BasicLayout({ image, hideFooter, children }) {
    const { t } = useTranslation();
    const { pathname } = useLocation();
  return (
    <PageLayout>
      {/*<DefaultNavbar*/}
      {/*  action={{*/}
      {/*    type: "external",*/}
      {/*    route: "https://creative-tim.com/product/material-dashboard-react",*/}
      {/*    label: "free download",*/}
      {/*    color: "dark",*/}
      {/*  }}*/}
      {/*/>*/}
      <MDBox
        key={pathname}
        className="page-fade-in"
        px={1}
        width="100%"
        height="100vh"
        mx="auto"
        sx={{
          backgroundColor: "#f2f3f6",
          backgroundImage: `linear-gradient(rgba(242, 243, 246, 0.7), rgba(242, 243, 246, 0.7)), url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Grid container spacing={1} justifyContent="center" alignItems="center" height="100%">
          <Grid
            item
            xs={11}
            sm={9}
            md={5}
            lg={4}
            xl={3}
            sx={{
              "@media (min-width:900px)": {
                maxWidth: "408px !important",
                flexBasis: "408px !important",
              },
            }}
          >
            {children}
          </Grid>
        </Grid>
      </MDBox>
      {!hideFooter && <Footer light />}
    </PageLayout>
  );
}

// Setting default props for the BasicLayout
BasicLayout.defaultProps = {
  hideFooter: false,
};

// Typechecking props for the BasicLayout
BasicLayout.propTypes = {
  image: PropTypes.string.isRequired,
  hideFooter: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default BasicLayout;
